// extracted by mini-css-extract-plugin
export default {"profileImage":"ProfileBubble_profileImage__dD+YR","hoverShadow":"ProfileBubble_hoverShadow__pdZTv"};